var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnion70Th(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 686.72,
    height: 676.12,
    viewBox: "0 0 515.04 507.09",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M178 362h105v145.09H178Zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M94 362h99v145.09H94Zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M308 359h96v148.09h-96Zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M260 362h65v145.09h-65Zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M388 362h105v145.09H388Zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M252 72h263.04v264H252Zm0 0"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "m206.492 503.59-24-138h30.446l26.042 61.75-12.71-61.75h28.226l24 138H247.02l-25.29-62 12.29 62h-27.528",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#ee3129",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M254.496 362.09h-32.52l6.403 31.105c-6.086-14.425-13.121-31.105-13.121-31.105h-36.93l25.219 145h34.734s-3.492-17.621-6.039-30.453c5.727 14.027 12.426 30.453 12.426 30.453h37.988l-25.219-145h-2.94m-2.942 7c.933 5.39 21.465 123.45 22.78 131h-24.964l-17.234-42.258c-4.032-9.875-20.637-44.742-20.637-44.742s16.816 79.73 18.258 87h-20.324l-22.782-131h23.961c.883 2.09 7.73 18.332 14.059 33.332 5.758 13.652 23.66 50.336 23.66 50.336s-16.266-76.363-17.77-83.668h20.993",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#f7b224",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M4.172 3.496H98l50.95 289.047H93.956L52.504 57.305H13.668L4.172 3.496",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#ee3129",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98-.004H0l10.73 60.809h38.836c.993 5.644 41.457 235.238 41.457 235.238h62.098L100.937-.004H98m-2.938 7c.985 5.59 48.325 274.145 49.72 282.047H96.894C95.902 283.398 55.44 53.805 55.44 53.805h-38.84L8.345 6.996h86.719",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#f7b224",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m99.11 365.59 6.203 37.258 11.046 66.336c3.98 20.238 17.329 30.238 24.403 32.906 5.746 2.168 28.074 1.86 33.984-.168 10.215-3.5 17.555-17.332 12.766-47.098l-8.707-52.289-6.149-36.945h-31.27l6.173 37.07 11.062 66.45c.348 2.648.809 5.648-3.18 5.648-6.863 0-7.359-1.168-8.367-5.645l-11.078-66.531-6.156-36.992H99.11",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#ee3129",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M172.656 362.09h-35.402l17.906 107.539.008.062c.059.45.133 1.067.156 1.563-3.219-.008-3.984-.324-4.137-.422-.19-.266-.507-1.652-.675-2.398-.035-.204-17.707-106.344-17.707-106.344H94.98l17.926 107.668c4.29 21.82 18.75 32.64 26.621 35.61 6.72 2.53 29.903 2.077 36.356-.134 6.637-2.273 21.387-11.793 15.086-50.964l-15.348-92.18h-2.965m-2.965 7 14.368 86.308c.98 6.09 1.46 11.657 1.46 16.622 0 14.496-4.101 23.918-11.906 26.593-5.351 1.832-26.922 1.973-31.617.203-6.07-2.289-18.52-11.57-22.203-30.308 0 0-15.477-92.953-16.55-99.418h23.628c.828 4.96 16.77 100.695 16.77 100.695l.02.098c1.39 6.18 3.378 8.375 11.78 8.375 2.32 0 4.121-.715 5.356-2.125 1.223-1.395 1.543-3.047 1.543-4.613 0-.977-.125-1.918-.235-2.743l-.03-.242s-15.481-92.988-16.56-99.445h24.176",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#f7b224",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M328.73 365.34c6.5-3 22.282-3.34 31.25 0 12.75 4.75 26 21.25 29.239 37.195l9.09 52.29c5.003 29.765-2.664 43.597-13.329 47.097-6.175 2.027-29.5 2.336-35.5.168-7.39-2.668-21.335-12.668-25.492-32.906l-11.535-66.336c-3.523-19.993 6.832-33.153 16.277-37.508m14.29 37.242 11.574 66.531c1.05 4.477 2.719 5.727 9.886 5.727 4.165 0 5.5-3.082 5.133-5.73l-11.554-66.45c-1.329-6.57-4.329-9.32-8.829-9.32-4.5 0-7.418 3.484-6.21 9.242",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#ee3129",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M327.262 362.16c-9.801 4.527-19 16.41-19 32.973 0 2.656.234 5.433.746 8.32l11.535 66.332c4.48 21.832 19.547 32.637 27.746 35.598 6.98 2.52 31.074 2.066 37.781-.133 6.914-2.27 22.282-11.781 15.692-51.008l-9.098-52.305c-3.476-17.12-17.285-34.593-31.465-39.875-9.414-3.511-26.222-3.46-33.937.098m23.406 136.637c-6.828-2.465-19.41-11.625-23.25-30.317l-11.516-66.234c-3.043-17.238 5.278-29.566 14.293-33.726 5.516-2.547 20.36-2.957 28.563.097 11.726 4.371 24.105 20.223 27.027 34.617l9.074 52.188c4.004 23.828.008 39.574-10.972 43.176-5.621 1.843-28.285 1.98-33.219.199M327.262 362.16",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#f7b224",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M341.477 393.324c-2.036 2.504-2.704 6.051-1.88 9.977l-.023-.117 11.586 66.628.027.102c1.672 7.125 5.79 8.426 13.293 8.426 3.508 0 5.57-1.52 6.68-2.793 1.578-1.809 2.277-4.328 1.922-6.914l-.02-.121-11.554-66.45c-2.047-10.117-7.805-12.222-12.278-12.222-3.175 0-5.93 1.238-7.753 3.484m4.992 8.66-.024-.12a8.864 8.864 0 0 1-.195-1.762c0-1.004.223-1.829.66-2.368.602-.738 1.594-.894 2.32-.894 1.422 0 4.079 0 5.399 6.515l11.52 66.254c.015.114.023.227.023.336 0 .418-.106.79-.285 1-.301.344-1.012.395-1.407.395-5.699 0-5.875-.461-6.46-2.945-.04-.239-11.551-66.41-11.551-66.41",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#f7b224",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m288.586 503.59-24-138h31.465l24 138h-31.465",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#ee3129",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M296.05 362.09h-35.624l25.219 145h38.57l-25.219-145h-2.945m-2.946 7c.942 5.39 21.473 123.45 22.786 131h-24.36c-.937-5.39-21.469-123.45-22.785-131h24.36",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#f7b224",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "m416.54 503.59-24-138h30.44l26.047 61.75-12.71-61.75h28.226l24 138h-31.477l-25.289-62 12.29 62h-27.528",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#ee3129",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M464.543 362.09H432.02l6.406 31.105c-6.086-14.425-13.121-31.105-13.121-31.105h-36.926l25.215 145h34.734s-3.492-17.621-6.039-30.453c5.727 14.027 12.426 30.453 12.426 30.453h37.988l-25.215-145h-2.945m-2.941 7 22.78 131h-24.964l-17.234-42.258c-4.032-9.875-20.637-44.742-20.637-44.742s16.816 79.73 18.258 87H419.48l-22.78-131h23.96c.88 2.09 7.73 18.332 14.059 33.332 5.758 13.652 23.66 50.336 23.66 50.336s-16.266-76.363-17.77-83.668h20.993",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#f7b224",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "m398.035 57.309-9.484-53.813H137.684l50.953 289.047h54.707l-19.89-112.844 69.308-.015-8.098-55.239h-70.95l-11.839-67.14 196.16.004",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#ee3129",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.55-.004H133.513l52.187 296.047h61.817l-19.891-112.844c7.367-.004 69.188-.015 69.188-.015l-9.122-62.239h-71.043c-.875-4.957-9.382-53.23-10.601-60.14l196.16.004L391.488-.004h-2.937m-2.938 7 8.254 46.813-196.164-.004 13.07 74.14h70.868c.726 4.946 6.12 41.75 7.07 48.243-7.18 0-69.43.011-69.43.011s18.547 105.215 19.895 112.844h-47.602c-.984-5.59-48.328-274.145-49.719-282.047h243.758",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#f7b224",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.625 235.258c0 22.965-18.613 41.578-41.578 41.578-22.965 0-41.582-18.613-41.582-41.578 0-22.965 18.617-41.582 41.582-41.582s41.578 18.617 41.578 41.582",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#ee3129",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.965 235.258c0 24.855 20.222 45.078 45.082 45.078 24.855 0 45.078-20.223 45.078-45.078 0-24.86-20.223-45.082-45.078-45.082-24.86 0-45.082 20.222-45.082 45.082m7 0c0-20.996 17.082-38.082 38.082-38.082 20.996 0 38.078 17.086 38.078 38.082 0 20.996-17.082 38.078-38.078 38.078-21 0-38.082-17.082-38.082-38.078M511.547 203.758c0 70.691-57.309 128-128 128-70.692 0-128-57.309-128-128 0-70.692 57.308-128 128-128 70.691 0 128 57.308 128 128",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#f7b224",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.379 202.758c-1.863 1.242-3.332 2.5-8.164 2.5-2.836 0-4.504-.168-6.836-1.332-2.332-1.168-4.332-2.336-5.164-4.168-.836-1.832-1.668-3.832-2.668-3.832-1 0-1.168-2.168-.332-3.168.832-1 3-3.168 4.332-3.168 1.332 0 2.332.836 2.668 2.336.332 1.5.5 4.832 2.5 5 2 .164 4.5.164 6.832-1.5 2.332-1.668 5.168-3.168 5.168-4.168s-1.5-3.832-3.668-4.832-6.332-2.168-8.832-4.168c-2.5-2-4.336-6-5.5-7-1.168-1-1.836-3.168-1.836-4.5 0-1.332-.164-3.5.836-4.332 1-.836 2.332-1.5 3.664-1.836 1.336-.332 2 1.5 2.5 2.836.5 1.332 1.668 2 1.168 3.664-.5 1.668.668 2.832 2.168 3.668 1.5.832 6.664 2.832 8.332 3.668 1.668.832 7.5 2 8.168.5.664-1.5 1.996-2.668 3.664-3.168 1.668-.5 2.168-3.168.668-3.168-1.332 0-3.168-.832-3.668-1.332-.5-.5-.8-1.52-.164-1.832 1-.5.164-1.336-2.168-1-.824.113-2.5-.836-2.168-1.836.336-1 1.5-.5 2.336-.5.832 0 1.664-2 1.164-2.832-.5-.832-2.164-1.668-1.664-3.668.5-2 2.164-2 3.664-1.664 1.5.332 5.492.84 6.5-.168 1.336-1.332 4.836-1.168 7.168-1 2.332.168 3.164-.832 4.332-1.332 1.168-.5 3.832.664 3.5 2.164-.332 1.5-1 4.668-.5 7.668s-.664 5.832-1.332 7.168c-.668 1.332-.332 3.5.168 4.832.5 1.332.996 4.832.164 6-.832 1.168-.832 2.832-.164 4.168.664 1.332-.668 3-1.168 4.832-.5 1.832-1.168 4.168 0 7s-.168 7.332 1.5 9.832c1.668 2.5 3.164 4.836 3.332 10.168.168 5.332 0 11.332 1 13.5 1 2.168 1.668 6.668 0 8.168-1.664 1.5-3.5 2.5-3.832 3.332-.332.832-.836 2.5-3.168 2.5-2.332 0-1.832 1.832-4.164 2-2.336.168-2.836-.168-2.836-1.168 0-1-1.664-1.5-1.332-2.832.332-1.332 1.332-2.832 2.668-2.832 1.332 0 3.496-1.836 4.164-2.836.668-1-1-2.832-3.332-3.832s-2.5-2.832-3.668-4c-1.164-1.168-1.832-3-2.832-3-1 0-2.668.168-3.832 1-1.168.832-3.668.168-4.836 2.5-1.164 2.332-3.168 5.164-4 7.832-.832 2.668-1.5 6.168-3.664 6.168-2.168 0-2.5-2.332-4.168-2.332-1.668 0-3.668-.836-5.168-1.668s-3.164-.832-4.332-.832c-1.168 0-1.832-1-1.332-3.5s1.832-4.004 3.5-4.336c1.664-.332 3.332 2.336 4.832 3.668 1.5 1.332 3.5.332 4-1.832.5-2.168-.168-8.168-.5-10-.332-1.836 2.168-4.668 5-7.5 2.832-2.836 6.5-4.504 6.5-6.336 0-1.832-1-6.5-2.168-7.5-1.164-1-1.5-1.832-3-.832M456.555 193.242c.234.145 23.453 14.649 29.41 41.442 4.418 19.89-1.25 42.136-1.305 42.355l6.774 1.766c.253-.97 6.156-24.067 1.363-45.64-6.617-29.77-31.54-45.255-32.598-45.895l-3.644 5.972",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#231f20",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.676 186.348c-19.985 18.394-24.824 36.605-25.02 37.375l6.778 1.746c.046-.172 4.625-17.07 22.98-33.973 19.727-18.156 45.137-19.066 45.39-19.074l-.179-6.996c-1.145.027-28.23.926-49.95 20.922M435.73 139.738c-20.64 17.051-26.562 34.895-26.804 35.645l6.66 2.152c.055-.164 5.64-16.734 24.601-32.398 20.34-16.801 45.024-16.055 45.266-16.043l.29-6.996c-1.114-.047-27.544-.918-50.013 17.64M376.93 137.508c.11.644 2.773 16.043 10.957 33.254 9.734 20.48 23.218 37.02 23.785 37.715l5.414-4.438c-.133-.164-13.52-16.601-22.879-36.285-7.742-16.285-10.352-31.27-10.379-31.418l-6.898 1.172M330.281 159.941c.227 1.137 5.824 28.07 28.145 47.301 22.484 19.371 40.09 18.555 40.828 18.508l-.395-6.988c-.156.008-15.722.527-35.863-16.825-20.445-17.613-25.8-43.117-25.851-43.37l-6.864 1.374",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#231f20",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.914 211.363c.16.125 16.121 12.676 22.063 37.38 4.394 18.28-3.797 40.741-3.88 40.96l6.563 2.442c.371-1 9.024-24.657 4.121-45.04-6.547-27.226-23.875-40.734-24.61-41.296l-4.257 5.554",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#231f20",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m406.379 77.922 12.305 70.933-.13-.082c-10.113-6.453-22.124-10.191-35.007-10.191-35.996 0-65.176 29.18-65.176 65.176s29.18 65.176 65.176 65.176c20.941 0 39.578-9.88 51.5-25.23l.074-.099 12.258 70.653s-32.332 21-71.664 17.664c-39.336-3.332-103.906-27.895-118.668-110.332-11.262-62.88 31.113-115.149 76-135.668 35-16 73.332-8 73.332-8",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#ee3129",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M252.047 203.758c0 72.508 58.988 131.5 131.5 131.5 72.508 0 131.5-58.992 131.5-131.5 0-72.508-58.992-131.5-131.5-131.5-72.512 0-131.5 58.992-131.5 131.5m7 0c0-68.649 55.848-124.5 124.5-124.5 68.648 0 124.5 55.851 124.5 124.5 0 68.648-55.852 124.5-124.5 124.5-68.652 0-124.5-55.852-124.5-124.5",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#f7b224",
      fillOpacity: 1
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnion70Th);
export default __webpack_public_path__ + "static/media/union_70th.54c4e002fc34718b54b136b2be1ac8da.svg";
export { ForwardRef as ReactComponent };